/**
 * What Export Contacts sends (OL-206): the ticked rows, or every contact that
 * matches the query the list last loaded. Kept free of '@/utils' so it stays
 * unit-testable.
 */

/** DataTables' own request keys. Everything else in its params is a list filter. */
const TABLE_KEYS = ['draw', 'columns', 'order', 'start', 'length', 'search'];

/**
 * @param {string[]} selectedIds uuids of the ticked rows
 * @param {object|null} matchingParams the table's ajax.params() when "all matching" is chosen
 * @returns {object|null} the request body, or null when nothing is selected
 */
export const exportPayload = (selectedIds, matchingParams = null) => {
  if (matchingParams) {
    const filters = Object.fromEntries(
      Object.entries(matchingParams).filter(([key]) => !TABLE_KEYS.includes(key))
    );
    const search = String(matchingParams.search?.value ?? '').trim();

    return { ...filters, all_matching: 1, ...(search ? { search } : {}) };
  }

  return selectedIds.length ? { ids: selectedIds } : null;
};
